import { render, staticRenderFns } from "./ChoosePage.vue?vue&type=template&id=a0e48d20&scoped=true"
import script from "./ChoosePage.vue?vue&type=script&lang=js"
export * from "./ChoosePage.vue?vue&type=script&lang=js"
import style0 from "./ChoosePage.vue?vue&type=style&index=0&id=a0e48d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e48d20",
  null
  
)

export default component.exports